import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { Component, signal, input, output, inject, computed } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NzImageModule } from 'ng-zorro-antd/image';
import { Marker } from '../../../models/classes/marker';
import { I18nService } from '../../../services/i18n.service';
import { UiService } from '../../../services/ui.service';
import { GLOBAL_CONSTANT } from '../../../constants/global.constant';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-dragdrop-marker-image',
  imports: [NzImageModule, DragDropModule, NzIconModule],
  templateUrl: './dragdrop-marker-image.html',
  styleUrls: ['./dragdrop-marker-image.scss'],
})
export class DragDropMarkerImageComponent {
  //Inputs as signals
  image = input<string>();
  wide = input<boolean>(false);
  markers = input<Marker[]>([]);

  // Outputs as signals
  imageLoad = output<Event>();

  // Injected services
  private ui = inject(UiService);
  public i18n = inject(I18nService);

  // Local state signals
  clientWidth = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  clientHeight = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  naturalWidth = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  naturalHeight = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  imageLoaded = signal<boolean>(false);

  //Computed for mobile check
  isMobile = computed(() => this.ui.IsMobile);

  // Get drag position dynamically
  getDragPosition(marker: Marker) {
    if (this.imageLoaded()) {
      return {
        x: marker.getClientX(
          this.clientWidth(),
          this.clientHeight(),
          this.naturalWidth(),
          this.naturalHeight()
        ),
        y: marker.getClientY(
          this.clientWidth(),
          this.clientHeight(),
          this.naturalWidth(),
          this.naturalHeight()
        ),
      };
    }
    return { x: 100, y: 100 };
  }

  // Handle drag end
  onDragEnded(marker: Marker, event: CdkDragEnd): void {
    if (this.imageLoaded()) {
      const x =
        marker.getClientX(
          this.clientWidth(),
          this.clientHeight(),
          this.naturalWidth(),
          this.naturalHeight()
        ) + event.distance.x;

      const y =
        marker.getClientY(
          this.clientWidth(),
          this.clientHeight(),
          this.naturalWidth(),
          this.naturalHeight()
        ) + event.distance.y;

      marker.setClientX(
        x,
        this.clientWidth(),
        this.clientHeight(),
        this.naturalWidth(),
        this.naturalHeight()
      );
      marker.setClientY(
        y,
        this.clientWidth(),
        this.clientHeight(),
        this.naturalWidth(),
        this.naturalHeight()
      );
    }
  }

  //Image load handler
  onImageLoaded(event: Event) {
    const target = event.target as HTMLImageElement;
    this.clientWidth.set(target.clientWidth);
    this.clientHeight.set(target.clientHeight);
    this.naturalWidth.set(target.naturalWidth);
    this.naturalHeight.set(target.naturalHeight);
    this.imageLoaded.set(true);
    this.imageLoad.emit(event);
  }
}
